module.exports = __webpack_public_path__ + "static/media/imagem28.a380e2cf.jpeg";